import React from 'react';

import { ChannelAuthMethod } from '../../stores/types/types';
import { SelectGroupOption } from '../general-components/select-group';
import SelectSmall from '../general-components/select-small';
import { Invitation } from '../../stores/reducers/invitations';
import type { InviteOption } from './invite-option-types';

enum RoleDescription {
	Presenter = 'can participate in streaming',
	Viewer = 'can view and comment',
}

// For now, the only options are EmailPassword or EmailPassword + SSO
// For just EmailPassword, we will use the existing inviteOptions.
// If we support SSO only, we can probably just filter the options:
// `menu.filter((option) => channelAuth.includes(option.authType))`
export const userInviteOptions: InviteOption[] = [
	{
		label: 'SSO Presenter',
		value: 'sso-presenter',
		description: RoleDescription.Presenter,
		authType: ChannelAuthMethod.SSO,
	},
	{
		label: 'Presenter',
		value: 'ep-presenter',
		description: RoleDescription.Presenter,
		authType: ChannelAuthMethod.EmailPassword,
	},
	{
		label: 'SSO Viewer',
		value: 'sso-viewer',
		description: RoleDescription.Viewer,
		authType: ChannelAuthMethod.SSO,
	},
	{
		label: 'Viewer',
		value: 'ep-viewer',
		description: RoleDescription.Viewer,
		authType: ChannelAuthMethod.EmailPassword,
	},
];

export const ssoOnlyInviteOptions: InviteOption[] = userInviteOptions.filter(
	(option) => option.authType === ChannelAuthMethod.SSO,
);

export const getInviteOptionIndexByValue = (
	menu: InviteOption[],
	isWatcher: boolean,
	authMethod: ChannelAuthMethod = ChannelAuthMethod.EmailPassword,
): number => {
	const index = menu.findIndex(({ authType, description }) => (
		authMethod === authType && description === (
			isWatcher ? RoleDescription.Viewer : RoleDescription.Presenter
		)
	));

	return index === -1 ? 0 : index;
};

export const getInviteOptionIndexByInvite = (
	menu: InviteOption[],
	invitation: Invitation,
): number => {
	const { authentication, watcher_only: watcherOnly } = invitation;

	return getInviteOptionIndexByValue(menu, !!watcherOnly, authentication);
};

interface InviteOptionsProps {
	menu: SelectGroupOption[];
	menuOptionIndex: number;
	onChange: (value: string) => void;
}

export default function InviteOptions({
	menu,
	menuOptionIndex,
	onChange,
}: InviteOptionsProps) {
	return (
		<SelectSmall
			options={menu}
			onChange={onChange}
			label={menu[menuOptionIndex]?.label ?? 'User Role'}
			selected={menu[menuOptionIndex] ?? menu[0]}
			dropdownPosition={'drop-left'}
			dropdown={true}
			optionHeight={60}
		/>
	);
}
